import { render } from "./AlphaGoat02.vue?vue&type=template&id=448e1065&scoped=true"
const script = {}

import "./AlphaGoat02.vue?vue&type=style&index=0&id=448e1065&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-448e1065"]])

export default __exports__